<!--
 * @Author: hongye
 * @Date: 2020-09-23 13:57:17
 * @LastEditTime: 2020-09-23 16:01:46
 * @Description: 
-->
<template>
  <div>
    <el-table v-if="codeList.length"  :data="codeList" border style="width:100%;border-radius: 4px;" max-height="600px">
      <el-table-column prop="code" label="code"></el-table-column>
      <el-table-column prop="msg" label="msg"></el-table-column>
      <el-table-column prop="desc" :label="$lang('描述')"></el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data(){
      return{
        codeList:[...[
          {code:"1",msg:"success",desc: this.$lang('成功')},
          {code:"0",msg:"fail",desc: this.$lang('失败')},
        ], ...this.dataList]
      }
  }
};
</script>

<style>
</style>